import request from '@/utils/request'
// 删除采购明细
export function delPurchaseList(id) {
  return request({
    url: '/iot/purchaseList/' + id,
    method: 'delete'
  })
}
